export default defineAppConfig({
  ui: {
    primary: "sky",
    gray: "cool",

    button: {
      icon: {
        loading: "i-svg-spinners-ring-resize",
      },
    },

    card: {
      body: {
        base: "text-sm space-y-2",
      },
    },

    dashboard: {
      card: {
        body: {
          base: "space-y-6",
        },
      },

      navbar: {
        wrapper: "dark:border-gray-700/50",
      },

      page: {
        wrapper: "bg-gray-50 dark:bg-gray-800",
      },

      panel: {
        content: {
          wrapper: "space-y-6",
        },
      },

      sidebar: {
        links: {
          active: "text-primary-500 dark:text-primary-300 before:bg-primary-50 dark:before:bg-primary-950",
          icon: {
            active: "text-primary-500 dark:text-primary-300",
          },
        },
      },
    },

    formGroup: {
      help: "text-xs",
    },

    notifications: {
      // Show toasts at the top right of the screen
      position: "top-0 bottom-auto",
    },

    table: {
      default: {
        loadingState: {
          icon: "i-svg-spinners-90-ring animate-none",
        },
      },
    },
  },

  // Workaround for https://github.com/nuxt/ui/issues/1045
  nuxtIcon: {},
});
